import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@wtag/rcl-icon';
import { EmphasisTag } from '@wtag/react-comp-lib';
import ContentLoaderPlaceholder from '@wtag/rcl-content-loader-placeholder';
import tripTypeIconMapper from 'sharedWebpack/helpers/tripTypeIconMapper';
import getTripType from 'sharedWebpack/IBE/lib/helpers/getTripType';
import { countryShape } from '../../admin/Orders/Show/helpers/shapes';
import CountryWithFlag from '../CountryWithFlag';

const JourneySummaryIndicator = ({
  originCountryInfo,
  destinationCountryInfo,
  trips,
  className,
  tripType,
  isLoading,
  isTripTypeVisible,
}) => {
  if (isLoading) {
    return (
      <ContentLoaderPlaceholder
        numberOfLines={1}
        showBackground={false}
        isRounded={false}
        contentWidth="260px"
      />
    );
  }

  const flightTripType = tripType || getTripType(trips);

  const {
    code: originCode,
    countryFlag: originFlag,
    countryName: originCountryName,
  } = originCountryInfo;

  const {
    code: destinationCode,
    countryFlag: destinationFlag,
    countryName: destinationCountryName,
  } = destinationCountryInfo;

  return (
    <div className={classNames('d-flex align-center column-gap-8', className)}>
      <Fragment>
        <CountryWithFlag code={originCode} flag={originFlag} name={originCountryName} />
        <Icon name={tripTypeIconMapper(flightTripType)} size="small" />
        <CountryWithFlag
          code={destinationCode}
          flag={destinationFlag}
          name={destinationCountryName}
        />
        {flightTripType && isTripTypeVisible && (
          <EmphasisTag
            text={I18n.t(flightTripType, {
              scope: 'components.ibe.results',
            })}
            type="neutral"
            size="tiny"
          />
        )}
      </Fragment>
    </div>
  );
};

JourneySummaryIndicator.defaultProps = {
  className: '',
  tripType: '',
  trips: [],
  isLoading: false,
  isTripTypeVisible: true,
  originCountryInfo: {},
  destinationCountryInfo: {},
};

JourneySummaryIndicator.propTypes = {
  originCountryInfo: PropTypes.shape(countryShape),
  destinationCountryInfo: PropTypes.shape(countryShape),
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      destinationCode: PropTypes.string,
      originCode: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  tripType: PropTypes.string,
  isLoading: PropTypes.bool,
  isTripTypeVisible: PropTypes.bool,
};

export default JourneySummaryIndicator;
